import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@workos-inc/authkit-react';
import { useEffect } from 'react';
import { PageLoader } from '@/components/page-loader';
import { Seo } from '@/components/seo';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  const { isLoading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        // onRedirectCallback stores the destination here instead of calling navigate()
        // (the SDK overrides it with history.replaceState). We use navigate() — not
        // window.location.replace() — so the page doesn't reload and the WorkOS
        // in-memory session tokens (stored in memoryStorage, not localStorage) survive.
        const redirectPath = sessionStorage.getItem('postAuthRedirect');
        sessionStorage.removeItem('postAuthRedirect');
        // redirectPath is an arbitrary runtime string (any deep-linked dashboard path),
        // so it can't satisfy TanStack Router's literal route-path union statically.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- dynamic deep-link path, see CLAUDE.md auth redirect pattern
        navigate({ to: (redirectPath || '/dashboard') as any });
      } else {
        navigate({ to: '/land-monitoring' });
      }
    }
  }, [isLoading, user, navigate]);

  return (
    <>
      {/* '/' redirects client-side; canonical points to the real landing page. */}
      <Seo
        title="Boundr — Property Reporting for NRI Land Owners"
        description="Boundr helps NRI property owners monitor their land in India with professional inspections, photo reports, and legal boundary verification."
        path="/"
        canonical="https://boundr.in/land-monitoring"
      />
      <PageLoader />
    </>
  );
}
